import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globals } from '@models/globals';
import { OpenIDConnectService } from '@services/auth/openid-connect.service';
import { Observable } from 'rxjs';

@Injectable()
export class AddAuthorizationHeaderInterceptor implements HttpInterceptor {
  constructor(private readonly openIDConnectService: OpenIDConnectService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!Globals.importUpload) {
      if (this.openIDConnectService.userAvailable) {
        request = request.clone({
          setHeaders: {
            Authorization: this.openIDConnectService.user.token_type + ' ' + this.openIDConnectService.user.access_token
          }
        });
      }
    }

    return next.handle(request);
  }
}
